// src/pages/taxonomy/Brands/BrandsFormPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { BrandsAPI } from '../../../api/v3/taxonomy-api-v3';

const BASE = '/app/sales/bagspa/taxonomy';

export default function BrandsFormPage() {
  const { id } = useParams();
  const history = useHistory();
  const isEdit = Boolean(id);

  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [active, setActive] = useState(true);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    async function load() {
      if (!isEdit) return;
      try {
        setLoading(true);
        const data = await BrandsAPI.show(id);
        const item = data?.item || data?.data || data;
        setName(item?.name || '');
        setCode(item?.code || '');
        setActive(Boolean(item?.active ?? true));
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [id, isEdit]);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = { name, code: code || null, active };
      if (isEdit) {
        await BrandsAPI.update(id, payload);
      } else {
        await BrandsAPI.create(payload);
      }
      history.push(`${BASE}/brands`);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{isEdit ? 'Edit' : 'New'} Brand</h3>
        <Link to={`${BASE}/brands`}>&larr; Back</Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label>Brand name</label>
          <input
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Unique name"
            required
          />
        </div>

        <div className="form-group mb-3">
          <label>Code (short)</label>
          <input
            className="form-control"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
            placeholder="e.g. LV, CH, OB"
            maxLength={6}
          />
          <small className="text-muted">Optional; will be stored uppercase.</small>
        </div>

        <div className="form-check mb-4">
          <input
            id="brand-active"
            type="checkbox"
            className="form-check-input"
            checked={!!active}
            onChange={e => setActive(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="brand-active">Active</label>
        </div>

        <button className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving…' : 'Save'}
        </button>
      </form>
    </div>
  );
}
